<div class="profile-selection-container">
  @if (profiles?.relatedProfiles?.length >= 1 && !vet && activeUsers.length > 0) {
    <app-info-box
      [title]="('steps.profileSelection.title' | translate) + typeAppointment.toLowerCase() + '?'"
      [description]="('steps.profileSelection.description' | translate) + typeAppointment.toLowerCase()"
    ></app-info-box>
    <div class="selectors-container">
      <nz-radio-group role="radiogroup" aria-label="Seleziona il profilo per la visita" [formControl]="profileSelected">
        <div class="selector">
          <label nz-radio [nzValue]="profiles" aria-label="{{ profiles?.['fullName'] }}">{{ profiles?.['fullName'] }}</label>
        </div>
        @for (profile of profiles.relatedProfiles; track profile) {
          @if (profile.isChangeProfileEnabled) {
            <div class="selector">
              <label nz-radio [nzValue]="profile" aria-label="{{ profile?.['fullName'] }}">{{ profile?.['fullName'] }}</label>
            </div>
          }
        }
        @if (isUserManagementAble) {
          <div class="selector last-element" role="button" tabindex="0" (click)="createProfile()" (keydown.enter)="createProfile()" (keydown.space)="createProfile(); $event.preventDefault()">
            <p>{{ 'steps.profileSelection.createProfile' | translate }}</p>
            <img src="/public/assets/images/plus-circle.svg" aria-hidden="true" />
          </div>
        }
      </nz-radio-group>
    </div>
  }
  @if (vet) {
    <app-info-box
      [title]="('steps.profileSelection.choose' | translate) + typeAppointment.toLowerCase()"
      description="{{ 'steps.profileSelection.this_choice' | translate }}"
    ></app-info-box>
    <div class="selectors-container">
      <nz-radio-group role="radiogroup" aria-label="Scegli la modalità di consultazione" [formControl]="vetTypeSelected">
        <div [ngClass]="modeSelection ? 'mode-selection' : ''" class="selector">
          <label nz-radio [nzValue]="'Telefonica'" aria-label="Consultazione telefonica">{{ 'steps.profileSelection.telephonic' | translate }}</label>
        </div>
        <div [ngClass]="modeSelection ? 'mode-selection' : ''" class="selector">
          <label nz-radio [nzValue]="'Video'" aria-label="Consultazione video">{{ 'steps.profileSelection.video' | translate }}</label>
        </div>
      </nz-radio-group>
    </div>
  }
  @if ((profileSelected.value || profiles?.relatedProfiles?.length === 0) && !vet) {
    <app-info-box
      [title]="('steps.profileSelection.title' | translate) + typeAppointment.toLowerCase() + '?'"
      [description]="('steps.profileSelection.description' | translate) + typeAppointment.toLowerCase()"
    ></app-info-box>
    <div class="data-container">
      <h3>{{ 'steps.profileSelection.dataProfile' | translate }}</h3>
      <nz-divider></nz-divider>
      <div class="info-container">
        <div>
          <p class="title">
            {{ 'steps.profileSelection.profile' | translate }}
          </p>
          <p class="value">{{ profileSelected.value.fullName ? profileSelected.value.fullName : '-' }}</p>
        </div>
        <div>
          <p class="title">
            {{ 'steps.profileSelection.telephone' | translate }}
          </p>
          <p class="value">{{ profileSelected.value.phone ? profileSelected.value.phone : '-' }}</p>
        </div>
        <div>
          <p class="title">
            {{ 'steps.profileSelection.email' | translate }}
          </p>
          <p class="value">{{ profileSelected.value.email ? profileSelected.value.email : '-' }}</p>
        </div>
      </div>
      <div class="subtitle-container">
        @if (profileSelected.value.fullName && profileSelected.value.phone && profileSelected.value.email) {
          <span nz-icon nzType="info-circle" nzTheme="fill"></span>
          <p class="inner-container">
            {{ 'steps.profileSelection.dataVerify' | translate }} <a role="button" tabindex="0" (click)="switchProfile(profileSelected)" (keydown.enter)="switchProfile(profileSelected)" (keydown.space)="switchProfile(profileSelected); $event.preventDefault()">{{ 'steps.profileSelection.goToProfile' | translate }}</a>
          </p>
        } @else {
          <span nz-icon nzType="close-circle" nzTheme="fill"></span>
          <p class="inner-container">
            {{ 'steps.profileSelection.dataVerifyError' | translate }}<a role="button" tabindex="0" (click)="switchProfile(profileSelected)" (keydown.enter)="switchProfile(profileSelected)" (keydown.space)="switchProfile(profileSelected); $event.preventDefault()">{{ 'steps.profileSelection.goToProfile' | translate }}</a>
          </p>
        }
      </div>
    </div>
  }
</div>
